import React from 'react';
import { Box, Chip, Typography } from '@mui/material';

export interface IncidentQueueBlockProps {
  children: React.ReactNode;
  eyebrow?: React.ReactNode;
  title?: React.ReactNode;
  description?: React.ReactNode;
  contextChip?: React.ReactNode;
  accent?: 'default' | 'workflow';
}

const IncidentQueueBlock: React.FC<IncidentQueueBlockProps> = ({
  children,
  eyebrow,
  title = 'Review queue',
  description = 'Items that need review, follow-up, or action.',
  contextChip,
  accent = 'default',
}) => (
  <Box
    sx={{
      pt: accent === 'workflow' ? 0.5 : 0,
    }}
  >
    <Box sx={{ mb: 1.5 }}>
      {eyebrow ? (
        <Typography variant="overline" color="primary" sx={{ fontWeight: 800, letterSpacing: '0.08em', display: 'block', mb: 0.3 }}>
          {eyebrow}
        </Typography>
      ) : null}
      <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1 }}>
        <Box sx={{ minWidth: 0 }}>
          <Typography sx={{ fontSize: 18, fontWeight: 700 }}>{title}</Typography>
          {description ? (
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          ) : null}
        </Box>
        {contextChip ? <Chip size="small" color="primary" variant="outlined" label={contextChip} sx={{ fontWeight: 700 }} /> : null}
      </Box>
    </Box>
    {children}
  </Box>
);

export default IncidentQueueBlock;
